import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetItemQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import * as documentApi from "../../api/documentApi/documentApi";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {
  EQDocument,
  documentTypeName,
  initializeDocument,
} from "../../models/serverModels/workOrder/EQDocument";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import DocumentForm from "./DocumentForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {documentSchema} from "../../validation/documentSchema";

const UpdateDocument = () => {
  const {id} = useParams();
  const {state} = useLocation();

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: document, isLoading: isGetLoading} = useGetItemQuery<ResponseItem<EQDocument>>({
    key: ["Document", id],
    api: () => documentApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQDocument>,
    Params.Update<EQDocument>
  >({
    api: documentApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(`/Document/List/${state}`);
        queryClient.invalidateQueries("DocumentList");
      },
    },
  });

  const methods = useForm<EQDocument>({
    defaultValues: document?.item || initializeDocument(),
    resolver: yupResolver(documentSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(document?.item);
  }, [document?.item, reset]);

  const onSubmit: SubmitHandler<EQDocument> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeDocument(), ...data, type: state},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle={documentTypeName[state]} />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <DocumentForm subText="파일 수정" captionColor="#546E7A" />
            <ConfirmButtonGroup
              link={`/Document/List/${state}`}
              cancelText="취소"
              confirmText="수정"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateDocument;
